import React, { useDeferredValue, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import bem from 'utils/bem';

import './index.sass';

const { block } = bem('range-field');

const RangeField = ({min, max, step, onChange, ...rest}) => {

    const [value, setValue] = useState(0);
    const deferredValue = useDeferredValue(value);

    const { setFieldValue, values: { saleSum } } = useFormikContext();
    const onRangeChange = (e) => {
        setValue(+e.target.value);
    }

    useEffect(() => {
        setFieldValue('saleSum', deferredValue);
    }, [deferredValue])

    return (
        <input className={block()}
               type='range'
               {...rest}
               min={min} max={max}
               step={step}
               onChange={onRangeChange}
               style={{ '--value': saleSum, '--min': min, '--max': max }}
               value={saleSum}
        />
    )
}

export default RangeField;
